const styles = {
  font: {
    ParagraphLarge: "font-normal leading-7 text-lg",
    LabelXSmall: "font-medium leading-4 text-xs",
    HeadingXSSmall: "font-semibold leading-6 text-base",
  },

  textAlign: {
    center: "text-center",
    left: "text-left",
    right: "text-right",
  },
  text: "group transition duration-300",
  textHover: {
    primary: "cursor-pointer",
    secondary: "",
  },
};

export default styles;
